
/**
 * 下拉窗
 * wangj
 */

const SgiFormComboboxEO = function () {
    return {
        emptyText: '未找到匹配值',
        inpPopTe: "--请选择--",
        showSearch: true,//搜索框
        // scId: 'SD_SC_PT_0001',//标准代码GUID
        alwBlk: true,
        allowClear: true,//支持清除
        // c : "attribute1",
        ctlH: 0,
        ctlN: "下拉窗",
        ctlW: 24,
        isDis: false,
        isHdn: false,
        lblW: 6,
        mulSel: false,// 设置是否允许多选 默认为false
        // n : "属性1",
        sNo: 0,
        // scH : 0,
        // t : "combox",
        te: "下拉窗",
        cId: '', // 系统唯一的表示，默认时系统会自动生成
        // useCodes:'',
        // autoSel : true,
        desId: "EP_EO_UI_3107",
        // isGw : true,
        // isLbl : false,
        // isRead : false,
        // isSrp : false,
        lblAlg: "right",
        // maxL : 500,
        // minL : 500,
        // msfTgt : "qtip",
        // useTim : 0,
        // visible : false,
        // x : "0",
        // y : "0",
    }
}

export { SgiFormComboboxEO };
export default SgiFormComboboxEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormComboboxEO.js